import ApiService from './ApiService';

class AuthService {

  constructor(router) {
    this.router = router;
  }

  async login(username, password) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/login',
        data: { username, password },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  }

  async fetchMyPermissions() {
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: '/my-permissions',
      });
      const raw = response.data.permissions || [];
      const permissions = raw.map(p => (typeof p === 'object' ? p.name : p));
      localStorage.setItem('permissions', JSON.stringify(permissions));
      return permissions;
    } catch (error) {
      return [];
    }
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/login';
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getPermissions() {
    try {
      const stored = localStorage.getItem('permissions');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  hasPermission(module) {
    return this.getPermissions().includes(module);
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
